<template>
  <div
    class="Dialog prize-detail"
    v-if="state.matches('participate.prizeList')"
    :class="state.matches('participate.prizeList.failure') ? 'error' : ''"
  >
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld"></div>
      <div class="pic-cloud"></div>

      <div class="icon-close" @click="send('CLOSE')"></div>
      <div class="title">
        <span>{{ (prizeBoxInfo && prizeBoxInfo.name) || "宝箱详情" }}</span>
      </div>

      <!-- 向前翻页 -->
      <div class="icon-prev"
           v-if="state.context.prizeListRank * 1 > 1 && state.context.prizeListShowAll"
           @click="getPrevPrizeList">
      </div>

      <!-- 向后翻页 -->
      <div
        class="icon-next"
        v-if="state.context.prizeListRank * 1 < GAME_INFO.drawGroupid[state.context.selectedMap].length && state.context.prizeListShowAll"
        @click="getNextPrizeList"
      ></div>

      <div class="inner-body">
        <!-- 奖品列表 -->
        <template v-if="state.matches('participate.prizeList.success')">
          <p class="desc">每次开箱可随机获得以下其一</p>
          <ul class="prize-list">
            <li class="item" v-for="(prize, index) in prizeList" :key="index">
              <span class="tag" v-if="prize.prizeLen > 0">已得*{{ prize.prizeLen }}</span>
              <div class="prize-box sm">
                <img :src="prize.url" />
              </div>
              <p class="name">{{ prize.name }}</p>
            </li>
          </ul>
        </template>

        <!-- 失败弹窗 -->
        <div class="inner-body" v-else-if="state.matches('participate.prizeList.failure')">
          <p class="content content--style">查询宝箱失败，请稍后重试</p>
          <div class="btns">
            <!-- <button class="btn">确定</button> -->
            <button class="btn btn--green" @click="send('RETRY')">重试</button>
          </div>
        </div>

        <!-- loading 弹窗 -->
        <div class="MIDAS-TOAST-loading MIDAS-TOAST-loading--style-two" v-else-if="state.matches('participate.prizeList.loading')">
          <i class="MIDAS-TOAST-loading__icon icon-load"></i>
          <p class="MIDAS-TOAST-loading__txt">加载中，请稍候...</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from "@vue/composition-api"

import { GAME_INFO } from "../configs"

export default {
  props: ["state", "send"],

  setup(props) {
    // 奖品列表
    const prizeList = computed(() => {
      return getPrizeListWithLength(props.state.context.prizeList)
    })

    // 获取前一个奖品列表
    const getPrevPrizeList = () => {
      props.send("FETCH_PRIZE_LIST", {
        rank: (props.state.context.prizeListRank * 1 - 1).toString(),
        showAll: true
      })
    }

    // 获取下一个奖品列表
    const getNextPrizeList = () => {
      props.send("FETCH_PRIZE_LIST", {
        rank: (props.state.context.prizeListRank * 1 + 1).toString(),
        showAll: true
      })
    }

    // 获取当前奖池信息
    const prizeBoxInfo = computed(() => {
      const filter = GAME_INFO.drawGroupid[props.state.context.selectedMap].filter(item => {
        return item.rank * 1 === props.state.context.prizeListRank * 1
      })

      return filter && filter.length ? filter[0] : null
    })

    // 返回奖品列表
    return {
      prizeList,
      getPrevPrizeList,
      getNextPrizeList,
      prizeBoxInfo,
      GAME_INFO
    }
  }
}

/**
 * 获取奖品列表
 * 奖池信息，若用户有中奖，也展示出来用户的中奖信息
 * @param prizeList
 * @returns {Array}
 */
function getPrizeListWithLength(prizeList) {
  if (!prizeList || !prizeList[0]) {
    return []
  }

  let tempPrizeList = []

  prizeList[0].forEach(prize => {
    let awards = prizeList[1].filter(award => {
      return award.award_id === prize.product_id
    })

    tempPrizeList.push({
      ...prize,
      prizeLen: awards && awards.length ? awards.length : 0
    })
  })

  // 筛选出所有的非末等奖物品
  return tempPrizeList.filter(item => item.level !== "least")
}
</script>
